export default "__VITE_ASSET__BlEuP$MP__"